// extracted by mini-css-extract-plugin
export default {"mainPage":"Main_mainPage__jL1Rq"};